import React, { useState, FC } from 'react';
import { useTranslate, ReferenceManyField, FunctionField, Datagrid } from 'react-admin';
import { Grid } from '@material-ui/core';
import { time, Longdash } from '~/utils';
import { StatusField } from '~/components/ra';
import Filters from './Filters';
import RaPagination from '../Pagination/RaPagination';
import { perPageDefault, rowsPerPageOptionsDefault } from '~/utils/pagination';
import ApplicationShow from './ApplicationShow';
import ApiLocalizedTextField from '../ApiLocalizedTextField';
import { ApplicationRecord } from '~/types/applications';
import {
  ApplicationStagesList,
  getTranslationPrefix,
} from '~/components/Applications/components/ApplicationStagesList';

type Target = 'individuals' | 'businesses';

type ApplicationsProps = {
  target: Target;
  [key: string]: any;
};

const Applications: FC<ApplicationsProps> = (props) => {
  const { target } = props;
  const translate = useTranslate();
  const t = (key: string, options?: any) => translate(`components.Applications.${key}`, options);

  const [filters, setFilters] = useState<any>({
    // createdFrom: time().subtract(1, 'months').toISOString(),
    // createdTo: time().toISOString(),
  });

  const [showData, setShowData] = useState<ApplicationRecord | null>(null);
  const handleOpen = (data: ApplicationRecord) => {
    setShowData(data);
  };
  const handleClose = () => setShowData(null);

  return (
    <>
      <ApplicationShow
        showData={showData}
        onClose={handleClose}
        target={target}
        targetId={props?.record?.id}
      />
      <Grid container justify='space-between' alignItems='center'>
        <Grid item>
          <Filters {...props} setFilters={setFilters} filters={filters} />
        </Grid>
      </Grid>
      <ReferenceManyField
        label={t('label')}
        reference='applications'
        pagination={
          <RaPagination
            defaultPerPage={perPageDefault}
            rowsPerPageOptions={rowsPerPageOptionsDefault}
          />
        }
        perPage={perPageDefault}
        filter={filters}
        {...props}
      >
        <Datagrid
          rowClick={(_id: string, _basePath: string, record: ApplicationRecord) =>
            handleOpen(record)
          }
        >
          <FunctionField
            label={t('columns.processName')}
            sortable={false}
            render={(record: ApplicationRecord) => (
              <ApiLocalizedTextField
                keyPrefix={getTranslationPrefix(record)}
                secondKey='name'
                label=''
              />
            )}
          />
          <FunctionField
            label={t('columns.createdAt')}
            sortable={false}
            render={(record: ApplicationRecord) =>
              record?.created ? time(record.created).format('lll') : Longdash
            }
          />
          <FunctionField
            label={t('columns.updatedAt')}
            sortable={false}
            render={(record: ApplicationRecord) =>
              record?.updated ? time(record.updated).format('lll') : Longdash
            }
          />
          <FunctionField
            label={t('columns.currentStages')}
            sortable={false}
            render={(record: ApplicationRecord) => <ApplicationStagesList application={record} />}
          />
          <StatusField label={t('columns.status')} sortable={false} />
        </Datagrid>
      </ReferenceManyField>
    </>
  );
};

export default Applications;
